import { c as createSurface } from './createSurface-e2c22227.js';

const SurfaceDark = Object.assign(createSurface('dark'), {
  displayName: 'SurfaceDark'
});
const SurfaceDarkInfo = Object.assign(createSurface('blue'), {
  displayName: 'SurfaceDarkInfo'
});
const SurfaceLight = Object.assign(createSurface('light'), {
  displayName: 'SurfaceLight'
});

export { SurfaceDarkInfo as S, SurfaceDark as a, SurfaceLight as b };
//# sourceMappingURL=index-ead5920e.js.map
